import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { requirePermission } from "@/lib/require-permission"
import { ShareEmailDialog } from "@/routes/_layout/quoting_/emails/-components/share-email-dialog"

export const Route = createFileRoute(
  "/_layout/quoting_/emails/_list/$emailId/share",
)({
  beforeLoad: async ({ context: { queryClient } }) => {
    await requirePermission(queryClient, "email:update", "/")
  },
  component: ShareEmailModal,
})

function ShareEmailModal(): React.ReactElement {
  const { emailId } = Route.useParams()
  const navigate = useNavigate()

  return (
    <ShareEmailDialog
      emailIds={[emailId]}
      onClose={() =>
        navigate({
          to: "/quoting/emails/$emailId",
          params: { emailId },
          search: true,
        })
      }
    />
  )
}
